import { jsxs as d, Fragment as j, jsx as l } from "react/jsx-runtime";
import { useDropzone as x } from "react-dropzone";
const g = ({
  children: e,
  onDrop: n,
  onDragEnter: s,
  onDragOver: i,
  onDragLeave: p,
  disabled: m,
  multiple: a = !0,
  accept: r = void 0,
  maxSize: u = 1 / 0,
  name: o = "dropzone"
}) => {
  const c = Array.isArray(r) ? Object.fromEntries(r.map((y) => [y, []])) : r, t = x({
    onDrop: n,
    multiple: a,
    accept: c,
    onDragEnter: s,
    onDragOver: i,
    onDragLeave: p,
    maxSize: u,
    disabled: m
  }), { getInputProps: f } = t;
  return /* @__PURE__ */ d(j, { children: [
    e(t),
    /* @__PURE__ */ l("input", { ...f(), name: o, "aria-label": o })
  ] });
};
export {
  g as Dropzone
};
//# sourceMappingURL=Dropzone.js.map
